module.exports = __webpack_public_path__ + "img/success-checkout.d1ff3895.svg";